import { useCallback, useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import { Settings } from '../../../interfaces/Settings/Settings';
import { getSettingsByType, upsertSettings } from '../../../api/Settings';
import { SettingsType } from '../../../interfaces/Settings/SettingsType';
import { GenericSettingsValue } from '../../../interfaces/Settings/GenericSettingsValue';
import { getSettingsValue, getUpdatedSettings } from '../../../utils/Settings';
import { Waiting } from '../../../components/Waiting/Waiting';
import { sharedStyles } from '../../../utils/Style';
import { SettingsRow } from '../../../components/Settings/SettingsRow';
import { SettingsValueType } from '../../../interfaces/Settings/SettingsValueType';

export const MngSettings = () => {
  const [settings, setSettings] = useState<Settings[]>([]);
  const [loading, setLoading] = useState(true);

  const refreshSettings = () => {
    setLoading(true);
    getSettingsByType(SettingsType.MNG)
      .then((s) => setSettings(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  const handleChange = useCallback(
    (key: string, newValue: GenericSettingsValue) =>
      setSettings(
        getUpdatedSettings(SettingsType.MNG, key, settings, newValue),
      ),
    [settings],
  );

  const handleSave = () => {
    setLoading(true);
    upsertSettings(settings)
      .then(() => {
        toast.success('Ayarlar başarıyla kaydedildi');
        refreshSettings();
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  return (
    <Paper
      sx={{
        p: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        height: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Waiting open={loading} />
      <Typography
        sx={{
          ...sharedStyles.h5,
          fontWeight: 'bold',
        }}
      >
        MNG Kargo
      </Typography>
      <Divider />

      <SettingsRow
        name='URL'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'mng_url')}
        onChange={(newValue) => handleChange('mng_url', newValue)}
      />
      <SettingsRow
        name='API Anahtarı'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'mng_api_key')}
        onChange={(newValue) => handleChange('mng_api_key', newValue)}
        masked
      />
      <SettingsRow
        name='Güvenlik Dizisi'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'mng_security_string')}
        onChange={(newValue) => handleChange('mng_security_string', newValue)}
        masked
      />
      <SettingsRow
        name='Müşteri Numarası'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'mng_customer_number')}
        onChange={(newValue) => handleChange('mng_customer_number', newValue)}
      />
      <SettingsRow
        name='Şifre'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'mng_password')}
        onChange={(newValue) => handleChange('mng_password', newValue)}
        masked
      />

      <Box sx={{ display: 'flex', flexGrow: 1 }} />
      <Box display='flex' justifyContent='flex-end'>
        <Button
          variant='contained'
          onClick={handleSave}
          sx={{ ...sharedStyles.buttonText, mt: 1.5 }}
        >
          Kaydet
        </Button>
      </Box>
    </Paper>
  );
};
